import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/course/book"

const courseBook = {
  courseBookListPage(pageSize, limit, versionId, keyWord) {
    return axios.get(pre + `/courseBookListPage`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          versionId: versionId,
          keyWord: keyWord
        }
    });
  },
  courseBookInfo(id) {
    return axios.get(pre + `/courseBookInfo`, {params: {id: id}});
  },
  courseBookSave(params) {
    return axios.post(pre + `/courseBookSave`, qs.stringify(params));
  },
  courseBookDelete(id) {
    return axios.delete(pre + `/courseBookDelete`, {params: {id: id}});
  },
}
export default courseBook;



// WEBPACK FOOTER //
// ./src/api/course/courseBook.js